module.exports = __webpack_public_path__ + "img/DASH.ae58a2a6.svg";